// extracted by mini-css-extract-plugin
module.exports = {"canvas":"CanvasWidgetWrapper_canvas__KcD9H"};